module.exports = __webpack_public_path__ + "img/p-single-3.9883bd33.jpg";